import { memo, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { StyledButton } from "@components";
import { AppDispatch, checkPayment } from "@redux";
import { breakpoint } from "@utilities";
import { IFareCart } from "@interfaces";
import _ from "lodash";

interface IProps {
    btnTitle?: string;
    onBtnClick?: () => void;
    page?: string;
    paymentOption?: string;
    disableNext?: boolean;
    isSubmitting?: boolean;
    totalPrice?: number;
    items?: IFareCart[];
}
const calculateUnitPrice = (item: IFareCart): number => {
    const providerId = _.get(item, "product.json.apiProviderId", 0);
    const hasGroup = _.get(item, "product.groupFaresForAvailabilityCheck", false);
    return providerId > 0 && hasGroup
        ? _.get(item, "availability.FarePrice.RRP", 0)
        : _.get(item, "availability.productPricingData.RRP", 0);
};

export const TotalPriceComponent = memo((props: IProps) => {
    const { btnTitle, onBtnClick, disableNext, items } = props;
    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
        dispatch(checkPayment());
    }, []);

    const totalPrice = useMemo(
        () => _.sumBy(items, (item) => calculateUnitPrice(item) * (item.booking_quantity ?? 0)),
        [items],
    );
    return (
        <Price totalPrice={totalPrice.toFixed(2)}>
            <div className="wrapper">
                <div className="totalPrice">
                    <span className="text">Total Sell Price</span>
                    <span className="value">
                        <div className="value_input">${totalPrice.toFixed(2)}</div>
                    </span>
                </div>
                <ButtonCheckout
                    $borderRadius="4px"
                    color={["#436CB2 0%", "#28B7C3 100%"]}
                    onClick={onBtnClick}
                    disabled={disableNext}
                    >{btnTitle}
                </ButtonCheckout>
            </div>
        </Price>
    );
});

const Price = styled.div<{ totalPrice: string }>`
    background-color: #fff;
    border-radius: 8px;

    ${breakpoint.breakIpad`
        width: 270px;
    `}

    .wrapper {
        display: flex;
        flex-direction: column;
        padding: 20px 16px;
        gap: 10px;

        ${breakpoint.breakMobile`
            flex-direction : row;
        `}
    }

    .totalPrice {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;

        ${breakpoint.breakMobile`
            width: 200px;
            flex-direction : column;
            align-items: start;
        `}
        .text {
            font-size: 14px;
            color: #6e7375;
            font-weight: 500;
        }

        .value {
            font-size: 24px;
            font-weight: 500;
            font-family: Plus Jakarta Sans;
        }
    }
`;

const ButtonCheckout = styled(StyledButton)`
    margin-top: 0px;
    height: 54px;
`;
